import { Pipe, PipeTransform } from '@angular/core';
import { QeqService } from '../../services/qeq/qeq.service';
import { QeqUser } from '../../interfaces/qeq.interface';
import { TokenExpirationService } from '../../services/token-expiration/token-expiration.service';

@Pipe({
  name: 'qeqPipe',
  pure: false, // Make the pipe impure so it re-evaluates when data changes
})
export class QeqPipe implements PipeTransform {
  private static pendingRequests = new Set<string>();

  constructor(
    private qeqService: QeqService,
    private tokenExpirationService: TokenExpirationService
  ) {}

  transform(value: string | Date | undefined): string {
    if (!value) return '';

    const externalId = typeof value === 'string' ? value : '';

    // Get cached QeQ data synchronously
    const cached = this.qeqService.getQeqFromStorage();

    // Check if data exists in cache
    if (cached?.data && Array.isArray(cached.data)) {
      const user = cached.data.find(
        (u: any) => u.personnelnumber === externalId
      );
      return user?.name || externalId;
    }

    // If no cached data and not already loading globally, trigger API call
    const REQUEST_KEY = 'qeq-data';
    if (!QeqPipe.pendingRequests.has(REQUEST_KEY)) {
      QeqPipe.pendingRequests.add(REQUEST_KEY);

      this.qeqService.getQeQ().subscribe({
        next: (response) => {
          QeqPipe.pendingRequests.delete(REQUEST_KEY);
          // The pipe will re-evaluate automatically due to being impure
        },
        error: (error) => {
          QeqPipe.pendingRequests.delete(REQUEST_KEY);
          console.error('Error fetching QeQ data in pipe:', error);

          // Handle 401 responses (token expired)
          if (error.status === 401 || error.status_code === 401) {
            console.warn(
              'Token expired while fetching QeQ data, handling expiration'
            );
            this.tokenExpirationService.handleTokenExpiration();
          }
        },
      });
    }

    // Return the original value while loading or if no data
    return externalId;
  }
}
